import React from 'react';
import CommonSidebar from "../Common/CommonSidebar";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import retrievePermission from "../../utils/retrievePermission";

//icons
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';


class AISidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            agentPermission: 0,
            agentRunPermission: 0,
            mlhostPermission: 0,
        };
    }

    async componentDidMount() {
        await this.retrieveAgentPermission();
        await this.retrieveAgentRunPermission();
        await this.retrieveMlhostPermission()
    }

    async retrieveAgentRunPermission(){
        let p = await retrievePermission(
            'AgentRunViewSet',
            'create',
            this.context.subscriberObject
        );
         this.setState(
            {
                agentRunPermission: p,
            }
         )
    }

    async retrieveAgentPermission(){
        let p = await retrievePermission(
            'AgentViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                agentPermission: p,
            }
        )
    }

    async retrieveMlhostPermission(){
        let p = await retrievePermission(
            'MLHostViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                mlhostPermission: p,
            }
        )
    }

    render() {
        return(
            <CommonSidebar
                groups={
                    [
                        {
                            title: 'AI',
                            items: [
                                {
                                    title: 'ML Серверы',
                                    link: '/mlhost/',
                                    icon: DeveloperBoardIcon,
                                    hide: !this.state.mlhostPermission,
                                },
                                {
                                    title: 'Агенты',
                                    link: '/agent/',
                                    icon: SmartToyIcon,
                                    hide: !this.state.agentPermission,
                                },
                                {
                                    title: 'Запуски агентов',
                                    link: '/agent_run/',
                                    icon: AutoAwesomeIcon,
                                    hide: !this.state.agentRunPermission,
                                },
                            ],
                        },
                    ]
                }
            />
        )
    }
}

export default AISidebar;
